import React from "react";
import TabWrapper from "./TabWrapper";
import { SettingsPageTab, TabProps } from "./types";

const GeneralTab = (props: TabProps) => {
  return <TabWrapper id={SettingsPageTab.GENERAL}>В разработке.</TabWrapper>;
};

export default GeneralTab;
